<script lang="ts">
  let { variant = 'bar' } = $props();
  let route = $state(window.location.hash);
  const links = [
    ['Overview', '/admin'], ['Properties', '/admin/properties'],
    ['Customers', '/admin/customers'], ['Organizations', '/admin/organizations'], ['Users', '/admin/users'],
    ['Administration workflows', '/admin/workflows'], ['Alerts', '/admin/alerts'],
  ];
  const pathname = $derived(route.replace(/^#/, '').split('?')[0].replace('/admin/companies', '/admin/organizations').replace(/^\/$/, '/admin'));
  function current(path: string) {
    return pathname === path || (path !== '/admin' && pathname.startsWith(path + '/')) ? 'page' : undefined;
  }
</script>
<svelte:window onhashchange={() => route = window.location.hash} />
{#if variant === 'menu'}
  {#each links as [label, path]}
    <li><a aria-current={current(path)} href={'#' + path} class="rounded-xl px-4 py-2 font-bold transition-colors {current(path) ? 'bg-primary/10 text-primary' : 'text-base-content/70 hover:bg-primary/10 hover:text-primary'}">{label}</a></li>
  {/each}
{:else}
<nav aria-label="Administration" class="admin-navigation">
  {#each links as [label, path]}
    <a aria-current={current(path)} href={'#' + path}>{label}</a>
  {/each}
</nav>
{/if}
<style>
  .admin-navigation {--admin-accent:#116b97; display:flex; flex-wrap:wrap; gap: .25rem 1.25rem; border-bottom:1px solid var(--color-base-300); margin-bottom:1.75rem; padding-bottom:.25rem;}
  :global(html.dark) .admin-navigation {--admin-accent:#85d2fa;}
  a {display:flex; align-items:center; min-height:44px; padding:.5rem 0; border-bottom:2px solid transparent; font-size:.8125rem; font-weight:500; color:var(--color-base-content); text-decoration:none;}
  a:hover {color:var(--admin-accent);}
  a[aria-current="page"] {border-bottom-color:currentColor; color:var(--admin-accent); font-weight:700;}
  a:focus-visible {outline:2px solid var(--admin-accent); outline-offset:4px; border-radius:2px;}
  @media(max-width:640px) {.admin-navigation {gap:0 1rem; margin-bottom:1.25rem;} a {font-size:.75rem;}}
</style>
